import React from 'react';
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const Loading = () => {
    return (
        <div className={"d-flex justify-content-center align-items-center"}
             style={{position: "fixed", width: "100%", height: "100%", left: "0", top: "0"}}>
            <Box sx={{display: 'flex', marginLeft: '15px'}}>
                <CircularProgress/>
            </Box>
            <h1>در حال بارگذاری...</h1>
        </div>
    )
}

export default Loading;
